<template>
  <div class="wrapCon">
    <!-- <p>政策详情页面</p> -->
    <div class="def-container">
      <div class="topNav">
        <div class="fs">
          <i class="el-icon-location" style="color: #008ce6"></i>您所在位置：
          <el-breadcrumb
            separator-class="el-icon-arrow-right"
            style="font-size: 16px; display: inline-block"
          >
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item
              :to="{ path: '/showPolicy' }"
              v-if="topNavFlag == 10"
              >政策库</el-breadcrumb-item
            >
            <el-breadcrumb-item
              :to="{ path: '/policyService' }"
              v-if="topNavFlag == 1"
              >税惠直达专区</el-breadcrumb-item
            >
            <el-breadcrumb-item :to="{ path: '/showPolicyDetail' }"
              >详情</el-breadcrumb-item
            >
          </el-breadcrumb>
        </div>
      </div>
    </div>
    <div class="def-container detailContainer">
      <div class="leftCon">
        <div class="titleCon">
          <p class="title fb">
            {{ detailData.title || detailData.name }}
          </p>
          <div class="subTitle">
            <span>{{ detailData.fbjg }}</span>
            <span>{{ detailData.fwzh }}</span>
            <!-- <span>发布时间：{{ detailData.publictime }}</span> -->
          </div>
        </div>
        <div style="text-align: right; width: 100%; margin-top: 20px">
          <el-radio-group v-model="showType">
            <el-radio-button label="政策条目"></el-radio-button>
            <el-radio-button label="政策原文"></el-radio-button>
          </el-radio-group>
          <!-- <el-button class="computeBtn" round @click="toPolicyDetail"
              >查看政策全文</el-button
            > -->
        </div>
        <div v-if="showType == '政策条目'">
          <div
            class="policyContent"
            v-for="(item, index) in detailData.entrys"
            :key="index"
          >
            <li>{{ index + 1 }}、{{ item.entryName }}</li>
          </div>
        </div>
        <div
          v-if="showType == '政策原文'"
          class="policyContent"
          v-html="detailData.content"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  components: {},
  props: {},
  computed: {
    ...mapGetters({
      userInfo: "getUserInfo",
      getDictList: "dictionary/getDictList",
      getDictLabel: "dictionary/getDictLabel",
    }),
  },
  data() {
    return {
      showType: "政策条目",
      topNavFlag: 1, //头部面包屑导航显示
      detailData: {},
    };
  },
  created() {
    let data = sessionStorage.getItem("policyContData");
    this.detailData = JSON.parse(data);
  },
  mounted() {},
  methods: {
    toPolicyDetail() {
      window.sessionStorage.setItem(
        "policyDetailData",
        JSON.stringify(this.detailData)
      );
      window.sessionStorage.setItem("flag", false);
      window.sessionStorage.setItem("status", false);
      this.$router.push({
        name: "showPolicyDetail",
      });
    },
  },
};
</script>

<style lang='scss' scoped>
@import "@/styles/global.scss";
$width: 1200px;
.fb {
  font-weight: bold;
}
.fs {
  font-size: 18px;
}
.wrapCon {
  width: 100%;
  background: #eff8ff;
  margin-top: -10px;
  .topNav {
    width: 100%;
    height: 52px;
    line-height: 52px;
    display: flex;
    justify-content: flex-start;
    div {
      display: flex;
      align-items: center;
    }
  }
}
.detailContainer {
  // width: $width;
  min-height: 1000px;
  margin: 10px auto;
  display: flex;
  justify-content: space-between;
  border: 1px solid #f4f4f4;
  padding: 30px;
  background-color: #fff;
  // background-color: #eff8ff;
  .leftCon {
    width: 100%;
    min-height: 300px;
    padding-right: 15px;
    .titleCon {
      width: 100%;
      border-bottom: 3px solid #0d1c28;
      text-align: center;
      margin-bottom: 10px;
      .subTitle span {
        font-size: 14px;
        color: #999;
        margin: 10px;
      }
      .tags {
        display: flex;
        justify-content: flex-start;
        margin-bottom: 10px;
        padding-top: 10px;
      }
    }
    .title {
      color: #0d1c28;
      font-size: 28px;
      margin: 10px auto;
    }
    .policyContent {
      font-size: 18px !important;
    }
  }
  .rightCon {
    width: 300px;
    min-height: 300px;
    .dept {
      width: 100%;
      height: 230px;
      // border: 1px solid #eee;
      border-radius: 3px;
      p {
        font-size: 18px;
        // border-bottom: 1px dashed #eee;
        color: #333;
        padding: 16px 0 16px 10px;
      }
      .middle {
        width: 100%;
        margin: 20px 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .deptName {
          font-size: 16px;
          margin: 10px auto;
        }
      }
      .policyConsult {
        cursor: pointer;
        width: 100px;
        height: 30px;
        margin: 0 auto;
        line-height: 30px;
        text-align: center;
        color: #fff;
        background-color: red;
      }
    }
    .project {
      width: 100%;
      min-height: 300px;
      // border: 1px solid #eee;
      border-radius: 3px;
      margin-top: 20px;
      .title {
        font-size: 18px;
        padding: 16px 0 16px 10px;
        // border-bottom: 1px dashed #eee;
      }
      .item {
        font-size: 16px;
        width: 100%;
        min-height: 100px;
        // border-bottom: 1px solid #eee;
        padding: 10px 0;
        p {
          padding: 0 10px;
          margin-bottom: 10px;
        }
        div {
          display: flex;
          justify-content: space-between;
          padding: 0 10px;
        }
      }
    }
    //  .project:last-child {
    //      border-bottom: none;
    //  }
  }
}
.computeBtn {
  background-color: $col-theme;
  //position: absolute;
  color: #fff;
  width: 180px;
  border: 1px solid #ff890b !important;
}
::v-deep .home-container {
  background-color: #eff8ff;
  // background-color: #eee !important;
  margin-top: -5px;
}
.detailContainer .leftCon .titleCon .tags {
  display: block;
}
</style>
